<template>
<div class="chapter">
<div class="inner_page">
<h2 style="font-family: Calisto MT;">Nazar's Journey</h2>
<ul style="font-family: Calisto Mt; margin-left: -10px; margin-top: 20px; font-weight: normal !important;">
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#toc_id_3">Copyright Information ©</a></li>
<li><a href="#/index_split_003#toc_id_4">Acknowledgement</a></li>
<li><a href="#/index_split_004#toc_id_5">Endorsements</a></li>
<li><a href="#/index_split_006#toc_id_6">Nazar’s JourneyIntroductionBy Joseph Pearce</a></li>
<li><span href="#/index_split_008#toc_id_7" title="Link target outside of Sample">About the Artwork</span></li>
<li><span href="#/index_split_010#toc_id_8" title="Link target outside of Sample">The Skylark</span></li>
<li><span href="#/index_split_011#toc_id_9" title="Link target outside of Sample">Nightmare of Cruel Memories</span></li>
<li><span href="#/index_split_012#toc_id_10" title="Link target outside of Sample">Mar Addai</span></li>
<li><span href="#/index_split_013#toc_id_11" title="Link target outside of Sample">Amira and Yousif</span></li>
<li><span href="#/index_split_014#toc_id_12" title="Link target outside of Sample">By Paths They Have NotKnown I Will Guide Them</span></li>
<li><span href="#/index_split_015#toc_id_13" title="Link target outside of Sample">Evening at Baba’s Farmhouse</span></li>
<li><span href="#/index_split_017#toc_id_14" title="Link target outside of Sample">The Good Samaritan</span></li>
<li><span href="#/index_split_018#toc_id_15" title="Link target outside of Sample">Checkpoint in the Wilderness</span></li>
<li><span href="#/index_split_019#toc_id_16" title="Link target outside of Sample">He Carried You UntilYou Reached This Place</span></li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3769aa2e